import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Domain modules here

@NgModule({
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule]
})
export class DomainsModule {}
